<script>


  import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
  import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
  import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
  import Icon from 'fa-svelte';
  import { createEventDispatcher } from 'svelte';
  import { fade } from 'svelte/transition';
  import { getFacebookLink,getLinkedinLink,getTwitterLink } from './data.js';
  import { getTrad } from './js/AppState';
  import SGMSApi from './js/SGMSApi';
  const dispatch = createEventDispatcher();

  function close(e) {
    SGMSApi.sendActionEvent(e, 'CloseShare' + name)
    dispatch("close")
  }

  function linkClick(e, name) {
    SGMSApi.sendActionEvent(e, 'Share_' + name)
  }

</script>





<div class="partage-screen" transition:fade>
  <div class="partage-popup">
    <div class="close" on:click={close} />
    <div class="content">
      <div>{$getTrad("Ecran_Partage_01")}</div>
      <div>{$getTrad("Ecran_Partage_02")}</div>

      <p class="sharelinks">
        <span>{$getTrad("Ecran_Partage_03")}</span>
        <span>
          <a target="_blank" on:click={(e) => { linkClick(e, "facebook") }} href={getFacebookLink($getTrad("facebook_end"))} class="i"><Icon  icon={faFacebookF} /></a>
          <a target="_blank" on:click={(e) => { linkClick(e, "twitter") }} href={getTwitterLink($getTrad("twitter_end"))} class="i"><Icon  icon={faTwitter}  /></a>
          <a target="_blank" on:click={(e) => { linkClick(e, "linkedin") }} href={getLinkedinLink($getTrad("linkedin_end"))} class="i"><Icon  icon={faLinkedinIn} /></a>
        </span>
      </p>
    </div>
  </div>
</div>


<style>

a {color: #FFF;}
  .partage-screen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(45, 68, 136, 0.8);

    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: auto;
    z-index: 3;
  }

  .partage-popup {
    position: relative;
    max-width: 413px;
    margin: 30px;
    border-radius: 30px 30px 0 0;
    padding: 40px;
    color: #fff;
    background: #00a7e6;
  }
  .partage-popup::after {
    content: "";
    position: absolute;
    top: 99%;
    left: 0;
    right: 0;

    height: 100px;
    background: url('../images/blue-bottom.png') no-repeat center center;
    background-size: 100% 100%;
  }

  .close {
    position: absolute;
    top: 30px;
    right: 30px;
    width: 20px;
    height: 20px;
    background: url('../images/closepopup.svg') no-repeat center center;
  }

  .content {
    text-align: center;
  }

  .sharelinks {
    border: 2px solid #FFF;
    padding: 10px;

    display: flex;
    justify-content: space-between;
  }

  .i { margin: 0 10px; }

</style>
